import { render, staticRenderFns } from "./ProductionProject.vue?vue&type=template&id=8e0bc988&scoped=true&"
import script from "./ProductionProject.vue?vue&type=script&lang=js&"
export * from "./ProductionProject.vue?vue&type=script&lang=js&"
import style0 from "./ProductionProject.vue?vue&type=style&index=0&id=8e0bc988&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0bc988",
  null
  
)

export default component.exports